import React from 'react'
import {Outlet} from 'react-router-dom'
import { Toaster } from 'react-hot-toast';
import Header from "../header/index";
import Footer from "../footer/index";

export default function Layout({ children }) {
    return (
        <>
            <Header/>
            <div className="cf-blk">
                <Outlet/>
            </div>
            <Footer/>
            <Toaster position="top-right" toastOptions={{duration: 5000}}/>
        </>
    );
};